// extracted by mini-css-extract-plugin
export default {"container":"Dunkun_container__bjdo4","mimo":"Dunkun_mimo__zLISb","textBox":"Dunkun_textBox__-IhNg","textList":"Dunkun_textList__ckNAf"};